export const NEWS_BAR_SECTION = "Singapore Budget 2025";
export const NEWS_BAR_SECTION_URL = "/keywords/singapore-budget-2025";
